import { trans } from '@lingoda/i18n';
import { useIsLearningTeams } from '@lingoda/learning-teams';
import { studentBookingPath } from '@lingoda/router';
import { Box } from '@lingoda/ui';
import { PlusGradient } from '@lingoda/ui/icons/PlusGradient';
import { LinkTab } from '../LinkTab';
import { BookClassesRoundButton } from './BookClassesRoundButton';
import type { TabCommonProps } from '../types';

export const BookClasses = (props: TabCommonProps) => {
    const isLearningTeams = useIsLearningTeams();

    return isLearningTeams ? null : (
        <LinkTab
            sx={{ padding: 0 }}
            to={studentBookingPath()}
            label={
                <Box>
                    <BookClassesRoundButton endIcon={<PlusGradient />} variant="outlined">
                        {trans('navigation.user.book-classes', {}, 'public-common')}
                    </BookClassesRoundButton>
                </Box>
            }
            {...props}
        />
    );
};
